import { CapabilitiesDetailDataItem } from "./_Data";

export const BusinessTech = (): CapabilitiesDetailDataItem => {
  return {
    title: "Business & Tech",
    slug: "business-tech",

    hero: {
      title:
        "Incididunt adipisicing fugiat <span>ex velit aliquip</span> sunt <span>enim consequat</span>.",
      description:
        "Laborum non Lorem ad aute dolor anim ex laboris mollit duis cupidatat sunt adipisicing.",
      linkPath: "/contact",
      parallaxTitle: "Duis dolore qui magna.",
    },

    whatIs: {
      bgcolor: "dark",
      dividerTitle: "What is Business & Tech?",
      title:
        "<span class='gradient'>Business & Tech</span> means <span class='gradient'>cupidatat</span> and <span class='gradient'>adipisicing</span> aute dolor anim ex laboris mollit duis <span class='gradient'>AI</span>, <span class='gradient'>AR/VR</span>, and <span class='gradient'>IoT</span>, to keep businesses competitive and efficient.",
      mainContent: undefined,
    },

    leadingTheWay: {
      bgcolor: "light",
      title:
        "<span class='gradient'>Redefining Technology</span> for Business Success",
      mainContent:
        "Empowering small to medium-sized businesses with cutting-edge, integrated technological solutions that drive innovation and efficiency.",
      asides: [
        {
          title: "Advanced GenAI Integration",
          content: [
            "Creating immersive augmented and virtual reality experiences that captivate and engage your audience.",
            "Our AR/VR development services bring your ideas to life, offering interactive and immersive experiences that enhance customer engagement, training, and marketing efforts.",
          ],
        },
        {
          title: "Immersive AR/VR Development",
          content: [
            "Tailored AI applications to meet the specific needs of your business, ensuring alignment with your goals and challenges.",
            "We develop bespoke AI solutions designed to address your unique business challenges, from optimizing operations to enhancing customer experiences.",
          ],
        },
        {
          title: "AI-Powered Solutions",
          content: [
            "Designing AI-driven applications to improve efficiency, decision-making, and customer experiences.",
            "We develop AI-powered solutions that streamline operations, enhance decision-making, and provide personalized customer experiences, driving efficiency and innovation in your business..",
          ],
        },
        {
          title: "ThreeJS and Edge Front-End Development",
          content: [
            "Crafting cutting-edge visual experiences with ThreeJS and advanced front-end technologies.",
            "We utilize ThreeJS and the latest front-end technologies to create stunning, interactive 3D visuals and edge computing solutions that enhance user engagement and provide a competitive edge for your business.",
          ],
        },
      ],
      titleWidthOverride: {
        sm: "100%",
        md: "100%",
        lg: "45%",
        xl: "45%",
      },
    },

    keyBenefits: {
      bgcolor: "dark",
      title: "<span class='gradient'>Key Benefits</span> of Business & Tech",
      mainContent:
        "Trust us for reliable, cutting-edge solutions that elevate your business and set you apart from the competition.",
    },

    capabilityProjects: [
      {
        title: "Unmatched Innovation",
        description:
          "Stay ahead with bleeding-edge technologies and design, setting your business apart with innovative solutions that are both unique and highly effective.",
        image: "project1.jpg",
      },
      {
        title: "Seamless Integration",
        description:
          "Benefit from our expertise in blending advanced technologies seamlessly, ensuring all components work together harmoniously for optimal performance.",
        image: "project1.jpg",
      },
      {
        title: "Scalability and Flexibility",
        description:
          "Optimized user journeys and seamless interactions drive higher conversion rates, turning visitors into customers and boosting overall sales.",
        image: "project3.jpg",
      },
    ],

    useCases: {
      bgcolor: "dark",
      title: "Example <span class='gradient'>use cases</span>",
      mainContent:
        "Trust us for reliable, cutting-edge solutions that elevate your business and set you apart from the competition.",
      asides: [
        {
          content: [
            "Business Process Automation",
            "Our AI-powered automation solutions help businesses automate routine tasks, improve efficiency, and reduce operational costs, allowing your team to focus on strategic activities.",
          ],
        },
        {
          content: [
            "ThreeJS for E-Commerce",
            "We use ThreeJS to develop interactive 3D product visualizations for e-commerce platforms, allowing customers to explore products in detail, enhancing their shopping experience and boosting sales.",
          ],
        },
        {
          content: [
            "AR/VR for Training",
            "Our AR/VR training solutions provide realistic simulations for various industries, from medical procedures to industrial equipment handling, offering hands-on experience without the risks associated with real-world training.",
          ],
        },
        {
          content: [
            "Customer Service Automation",
            "We implement AI-powered chatbots and virtual assistants using Large Language Models (LLMs) to handle customer inquiries 24/7, providing instant responses and solutions. This reduces the workload on human agents, allowing them to focus on more complex issues and improving overall customer satisfaction.",
          ],
        },
      ],
    },

    contactCTAMain: {
      bgcolor: "dark",
    },

    whyChooseUs: undefined,

    projects: {
      dividerTitle: "Innovative Tech // Who We’ve Worked With",

      projects: [
        {
          title: "DockPro // Apple Vision Pro App",
          description:
            "Explore how color psychology can dramatically alter customer perception and engagement in our latest deep dive into the world of design.",
          image: "project1.jpg",
        },
        {
          title: "Thrifty Traveler CardGenius",
          description:
            "Discover the future of user interface design and how emerging technologies are reshaping our interactions with digital environments.",
          image: "project1.jpg",
        },
        {
          title: "Project Title",
          description:
            "Learn the top design principles that every aspiring designer should know to create visually compelling and effective layouts.",
          image: "project3.jpg",
        },
      ],
    },

    logos: {
      bgcolor: "dark",
      dividerTitle: "Innovative Tech // Who We’ve Delivered For",
      logos: [
        {
          image: "../assets/experience-logos/aws_logo.png",
          alt: "aws_logo",
        },
        {
          image: "../assets/experience-logos/aws_logo.png",
          alt: "aws_logo",
        },
        {
          image: "../assets/experience-logos/aws_logo.png",
          alt: "aws_logo",
        },
      ],
    },

    dockItemsMain: {
      title: "Services",
      dividerTitle: "Innovative Tech Services",
      dockItems: [
        "GenAI Integration",
        "AR/VR Development",
        "AI-Powered Solutions",
        "<span class='camel-case'>IoT</span> Solutions",
        "Immersive Experience Design",
        "Cloud Native Applications",
        "Conversational AI",
        "Mixed Reality (MR) Applications",
        "Service",
        "Service",
        "Service",
        "Service",
        "Service",
      ],
    },

    dockItemsSecondary: {
      title: "Deliverables",
      dividerTitle: "UX and Product Design Deliverables",
      dockItems: [
        "High-Fidelity Prototypes",
        "Fully Functional AR/VR Experiences",
        "AI-Driven Applications",
        "Conversational AI Interfaces",
        "Interactive Prototypes",
        "Integrated GenAI Solutions",
        "Visual Style Guides",
        "Design System Documentation",
        "Responsive Web Design Mockups",
        "Mobile App Design Mockups",
        "High Fidelity Designs",
        "Operational Prototypes",
        "Product Redlines",
      ],
    },

    faqs: [
      {
        summary: "Question Title",
        details:
          "Fugiat cupidatat aute mollit officia sint enim ut ex. Exercitation et est commodo mollit ut ex veniam. Fugiat nostrud ullamco occaecat minim consectetur. Quis sit incididunt proident nisi non consequat aliquip cupidatat eu veniam nisi nulla duis id.",
      },
      {
        summary: "Question Title",
        details:
          "Fugiat cupidatat aute mollit officia sint enim ut ex. Exercitation et est commodo mollit ut ex veniam. Fugiat nostrud ullamco occaecat minim consectetur. Quis sit incididunt proident nisi non consequat aliquip cupidatat eu veniam nisi nulla duis id.",
      },
      {
        summary: "Question Title",
        details:
          "Fugiat cupidatat aute mollit officia sint enim ut ex. Exercitation et est commodo mollit ut ex veniam. Fugiat nostrud ullamco occaecat minim consectetur. Quis sit incididunt proident nisi non consequat aliquip cupidatat eu veniam nisi nulla duis id.",
      },
      {
        summary: "Question Title",
        details:
          "Fugiat cupidatat aute mollit officia sint enim ut ex. Exercitation et est commodo mollit ut ex veniam. Fugiat nostrud ullamco occaecat minim consectetur. Quis sit incididunt proident nisi non consequat aliquip cupidatat eu veniam nisi nulla duis id.",
      },
      {
        summary: "Question Title",
        details:
          "Fugiat cupidatat aute mollit officia sint enim ut ex. Exercitation et est commodo mollit ut ex veniam. Fugiat nostrud ullamco occaecat minim consectetur. Quis sit incididunt proident nisi non consequat aliquip cupidatat eu veniam nisi nulla duis id.",
      },
    ],

    contactCTASecondary: {
      bgcolor: "dark",
    },
  };
};
